<template>
<div class='fw-check-box__wrapper'
     :style='{
         marginBottom: noIndent ? 0 : `8px`,
     }'
     :class='[
         type,
         {
             "fw-is-selected": isSelected || showMinus,
             "fw-is-disabled": disabled
         }]'>
    <div class='fw-check-box__container'
         :class='type'
         @click.stop='toggleCheck'>
        <input type='checkbox'
               :disabled='disabled'
               :name='name'
               :checked='model'>

        <div v-if='isCheckboxTypeWithText && isSelected'
             class='fw-check-box__inner-with-text'>
            <FwIcon
                class='h-mt-2'
                icon='ok'
                size='12'
                color='#fff'>
            </FwIcon>
        </div>

        <FwIcon
            v-if='isBaseView && isSelected'
            class='h-mt-2'
            icon='ok'
            :size='iconCheckedSize'
            color='#27DBBD'>
        </FwIcon>

        <template v-if='isFormView'>
            {{ text }}
        </template>
        <template v-if='isCheckboxTypePlus'>
            <span class='h-ml-10 h-font-16 h-height-100p h-flex h-flex-center'>
                {{ !isSelected ? `+` : `x` }}
            </span>
        </template>
        <div v-if='isItemCheckedView'
             class='fw-check-box__item h-flex-space-between h-flex h-flex-center h-ph-20'
             :style='{ width: itemWidth }'>
            <div class='h-flex-center'>
                <FwIcon
                    class='h-mt-2'
                    :icon='iconLeftSide'
                    :size='iconCheckedSize'
                    color='#213F6B'>
                </FwIcon>
                <p
                    class='h-font-14 h-fw-500'
                    :class='{ "h-pl-15": !noIndent }'>
                    {{ text }}
                </p>
            </div>
            <div class='h-pos-rel h-flex-center'>
                <div class='icon-checked__background'>
                </div>
                <div class='h-pos-abs h-mt-2'>
                    <FwIcon
                        :icon='iconRightSide'
                        size='12'
                        color='#ffffff'>
                    </FwIcon>
                </div>
            </div>
        </div>
        <div v-if='isItemCheckedCommonWithText'
             class='fw-check-box__item h-flex h-align-items-center'
             :style='{ width: itemWidth }'>
            <div class='fw-check-box__item__square'>
                <div v-if='showMinus'
                     class='fw-check-box__item__minus'>
                </div>
                <FwIcon
                    v-else-if='isSelected'
                    icon='ok'
                    class='h-mt-2'
                    size='9px'
                    color='#fff'>
                </FwIcon>
            </div>
            <div class='fw-check-box__item__text'>
                {{ text }}
            </div>
        </div>
        <div v-if='isItemCheckedViewWhite'
             class='icon-white__background h-flex h-flex-center h-ph-20'
             :class='{
                 "h-flex-space-between": itemCheckedRight,
                 "h-flex-dir-row-reverse h-flex-justify-end": !itemCheckedRight,
                 "icon-blue__background--round": !itemCheckedRight && !isSquare
             }'
             :style='{ width: itemWidth }'>
            <p
                class='h-font-14 h-fw-500'
                :class='{ "h-pl-15": !noIndent }'>
                {{ text }}
            </p>
            <div class='h-pos-rel h-flex-center' :style='iconStyles'>
                <div class='icon-checked__background'>
                    <FwIcon
                        class='h-mt-2'
                        icon='ok'
                        size='12'
                        color='#fff'>
                    </FwIcon>
                </div>
            </div>
        </div>
        <div v-if='isItemCheckedViewWhiteRound'
             class='icon-white__background icon-white__background--round h-flex-space-between h-flex h-flex-center h-ph-20'
             :style='[{
                 width: itemWidth,
                 borderRight: isBorderRight ? itemBorderRight : 0,
                 borderLeft: itemBorderLeft
             }, styles]'>
            <p
                class='h-font-14 h-fw-500'
                :class='{ "h-pl-15": !noIndent }'>
                {{ text }}
            </p>
            <div v-if='!$slots.deleteBtn' class='h-pos-rel h-flex-center'>
                <div class='icon-checked__background'>
                    <FwIcon
                        class='h-mt-2'
                        icon='ok'
                        size='12'
                        color='#fff'>
                    </FwIcon>
                </div>
            </div>
            <div v-if='$slots.deleteBtn'
                 class='h-pos-rel h-flex-center'>
                <div class='icon-red__background--round'>
                    <div class='icon-checked__background'>
                        <slot name='deleteBtn'></slot>
                    </div>
                </div>
            </div>
        </div>
        <div v-if='isItemCheckedViewWhiteTransparent'
             class='icon-white__background--transparent h-flex-space-between h-flex h-flex-center h-ph-20'
             :class='{
                 "h-flex-space-between": itemCheckedRight,
                 "h-flex-dir-row-reverse h-flex-justify-end": !itemCheckedRight,
                 "icon-blue__background--round": !itemCheckedRight && !isSquare
             }'
             :style='[{
                 width: itemWidth,
                 borderRight: isBorderRight ? itemBorderRight : 0,
             }, styles]'>
            <p
                class='h-font-14 h-fw-500'
                :class='{ "h-pl-15": !noIndent }'>
                {{ text }}
            </p>
            <div class='h-pos-rel h-flex-center' :style='iconStyles'>
                <div class='icon-checked__background'>
                    <FwIcon
                        class='h-mt-2'
                        icon='ok'
                        size='12'
                        color='#fff'>
                    </FwIcon>
                </div>
            </div>
        </div>
    </div>

    <label v-if='$slots.default'
           class='fw-check-box__label'
           :for='name'
           @click='toggleCheck'>
        <slot></slot>
    </label>
</div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import FwIcon from '../FwIcon.vue';

const CHECKBOX_TYPE_BASE: string = 'base';
const CHECKBOX_TYPE_COMMON_WITH_TEXT: string = 'common-with-text';
const CHECKBOX_TYPE_FORM: string = 'form';
const CHECKBOX_TYPE_PLUS: string = 'plus';
const CHECKBOX_TYPE_SMALL: string = 'small';
const CHECKBOX_TYPE_FORM_LIGHT: string = 'form-light';
const CHECKBOX_TYPE_ITEM_CHECKED: string = 'icon-checked';
const CHECKBOX_TYPE_WITH_TEXT: string = 'with-text';
const CHECKBOX_TYPE_WHITE_WITH_TEXT: string = 'white-with-text';
const CHECKBOX_TYPE_WHITE_WITH_TEXT_ROUND: string = 'white-with-text-round';
const CHECKBOX_TYPE_WHITE_WITH_TEXT_TRANSPARENT: string = 'white-with-text-transparent';

const CHECKBOX_TYPES: Array<string> = [
    CHECKBOX_TYPE_BASE,
    CHECKBOX_TYPE_COMMON_WITH_TEXT,
    CHECKBOX_TYPE_FORM,
    CHECKBOX_TYPE_PLUS,
    CHECKBOX_TYPE_FORM_LIGHT,
    CHECKBOX_TYPE_SMALL,
    CHECKBOX_TYPE_ITEM_CHECKED,
    CHECKBOX_TYPE_WITH_TEXT,
    CHECKBOX_TYPE_WHITE_WITH_TEXT,
    CHECKBOX_TYPE_WHITE_WITH_TEXT_ROUND,
    CHECKBOX_TYPE_WHITE_WITH_TEXT_TRANSPARENT,
];

@Component({
    components: { FwIcon },
    model: {
        prop: 'model',
        event: 'change',
    },
})
export default class FwCheckbox extends Vue {
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: Boolean, default: false }) readonly singleSelect!: boolean;
    @Prop({ type: Boolean, default: false }) readonly noIndent!: boolean;
    @Prop({ type: Boolean, default: true }) readonly itemCheckedRight!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isBorderRight!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isSquare!: boolean;
    @Prop({ type: Boolean, default: false }) readonly showMinus!: boolean;
    @Prop(String) readonly name!: string;
    @Prop(String) readonly text!: string;
    @Prop({ type: Object, default: null }) readonly styles!: { [key: string]: string };
    @Prop({ type: Object, default: null }) readonly iconStyles!: { [key: string]: string };
    @Prop({ type: String, default: '16' }) readonly iconCheckedSize!: string;
    @Prop({ type: String, default: '315px' }) readonly itemWidth!: string;
    @Prop({ type: String, default: '10px solid grey' }) readonly itemBorderLeft!: string;
    @Prop({ type: String, default: '1px solid #BDC6D3' }) readonly itemBorderRight!: string;
    @Prop({ type: String, default: 'reccurance-icon' }) readonly iconLeftSide!: string;
    @Prop({ type: String, default: 'ok' }) readonly iconRightSide!: string;
    @Prop([String, Boolean, Object, Number, Array]) readonly model!: string | boolean | Object | number | Array<any>;
    @Prop([String, Boolean, Object, Number]) readonly value!: string | boolean | Object | number;
    @Prop({ type: String, default: CHECKBOX_TYPE_BASE, validator: (type: string) => CHECKBOX_TYPES.includes(type) })
    readonly type!: string;

    get hasValue(): boolean {
        return !!this.value;
    }

    get isBaseView() {
        return this.type === CHECKBOX_TYPE_BASE || this.type === CHECKBOX_TYPE_SMALL;
    }

    get isFormView() {
        return this.type === CHECKBOX_TYPE_FORM || this.type === CHECKBOX_TYPE_FORM_LIGHT || this.type === CHECKBOX_TYPE_PLUS;
    }
    get isItemCheckedView() {
        return this.type === CHECKBOX_TYPE_ITEM_CHECKED;
    }

    get isCheckboxTypePlus() {
        return this.type === CHECKBOX_TYPE_PLUS;
    }

    get isCheckboxTypeWithText() {
        return this.type === CHECKBOX_TYPE_WITH_TEXT;
    }

    get isItemCheckedViewWhite() {
        return this.type === CHECKBOX_TYPE_WHITE_WITH_TEXT;
    }

    get isItemCheckedViewWhiteRound() {
        return this.type === CHECKBOX_TYPE_WHITE_WITH_TEXT_ROUND;
    }

    get isItemCheckedViewWhiteTransparent() {
        return this.type === CHECKBOX_TYPE_WHITE_WITH_TEXT_TRANSPARENT;
    }

    get isItemCheckedCommonWithText() {
        return this.type === CHECKBOX_TYPE_COMMON_WITH_TEXT;
    }

    get isModelArray(): boolean {
        return Array.isArray(this.model);
    }

    get isSelected(): boolean {
        if (Array.isArray(this.model)) {
            return this.model.includes(this.value) || this.model.some(item => JSON.stringify(item) === JSON.stringify(this.value));
        }

        if (this.hasValue) {
            return this.model === this.value;
        }

        return this.model === true;
    }

    showDeletePopup() {
        this.$emit('showDeletePopup', this.value);
    }

    removeItemFromModel(newModel: Array<any>) {
        if (~newModel.indexOf(this.value)) {
            newModel.splice(newModel.indexOf(this.value), 1);
        } else if (
            typeof this.value === 'object' &&
            !Array.isArray(this.value) &&
            this.value !== null
        ) {
            const index = newModel.findIndex(item => JSON.stringify(item) !== JSON.stringify(this.value));
            newModel.splice(index, 1);
        }
    }

    handleArrayCheckbox() {
        if (!Array.isArray(this.model)) return;
        let newModel: Array<any> = this.model;

        if (!this.isSelected && Array.isArray(newModel)) {
            if (this.singleSelect) {
                newModel = [this.value];
            } else {
                newModel.push(this.value);
            }
        } else {
            this.removeItemFromModel(newModel);
        }

        this.$emit('change', newModel);
    }

    handleSingleSelectCheckbox() {
        this.$emit('change', this.isSelected ? null : this.value);
    }

    handleSimpleCheckbox() {
        this.$emit('change', !this.isSelected);
    }

    toggleCheck(): void {
        if (this.$slots.deleteBtn) {
            this.showDeletePopup();
            return;
        }
        if (!this.disabled) {
            if (this.isModelArray) {
                this.handleArrayCheckbox();
            } else if (this.hasValue) {
                this.handleSingleSelectCheckbox();
            } else {
                this.handleSimpleCheckbox();
            }
        }
        if (this.isSelected) {
            this.$emit('input');
        }
    }
}
</script>

<style lang="sass">
.fw-check-box
    &__wrapper
        display: inline-flex
        align-items: center

        &.fw-is-selected
            .fw-check-box__container
                &.base
                    border: 2px solid $main-green

                &.with-text
                    border: 2px solid $main-green
                    background-color: $main-green

                &.form, &.form-light
                    background-color: $main-green
                    color: #fff

                &.plus
                    background-color: $dark-blue
                    color: #fff

                &__background
                    background-color: $main-green
                    color: #fff

                &.common-with-text
                    .fw-check-box__item__square
                        background-color: $dark-blue

        &.fw-is-disabled
            opacity: .5

            .fw-check-box__container,
            .fw-check-box__label
                cursor: default

        &.with-text
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center

            .fw-check-box__label
                margin-left: 0
                margin-top: 5px

        input
            position: absolute
            left: -999em
            margin: 0
            opacity: 0

    &__container
        position: relative
        cursor: pointer
        display: flex
        align-items: center
        justify-content: center
        user-select: none

        &.small
            flex: 0 0 15px
            font-size: 5px
            border-radius: 5px
            width: 15px
            height: 15px
            border: 2px solid $main-green
            box-sizing: content-box

        &.common-with-text
            display: flex
            align-items: center

            .fw-check-box__item__minus
                width: 8px
                height: 2px
                background-color: #fff

            .fw-check-box__item__square
                flex: 0 0 14px
                font-size: 5px
                border-radius: 4px
                width: 14px
                height: 14px
                border: 2px solid #B1B1B1
                box-sizing: content-box
                display: flex
                align-items: center
                justify-content: center

            .fw-check-box__item__text
                font-size: 14px
                font-weight: 500
                padding-left: 10px

        &.base
            flex: 0 0 21px
            font-size: 5px
            border-radius: 5px
            width: 21px
            height: 21px
            border: 2px solid $main-green
            box-sizing: content-box

        &.with-text
            flex: 0 0 18px
            font-size: 5px
            border-radius: 3px
            width: 18px
            height: 18px
            background-color: #fff
            border: 2px solid rgba(32, 63, 106, 0.4)
            box-sizing: content-box

        &.icon-checked
            border-radius: 10px
            background-color: #F7F8FA

        &.form, &.form-light
            flex: 1 0 45px
            font-size: 16px
            border-radius: 10px
            height: 45px
            padding: 15px 19px
            background-color: $middle-gray
            line-height: 19px
            color: $dark-blue
            font-weight: 600
            white-space: nowrap

        &.plus
            background-color: transparent
            border: 1px solid $dark-blue
            color: $dark-blue
            flex: 1 0 45px
            font-size: 14px
            border-radius: 20px
            height: 45px
            padding: 15px 19px
            line-height: 19px
            font-weight: 600
            white-space: nowrap

        &.form
            background-color: $middle-gray

        &.form-light
            background-color: $light-gray

        &.with-text
            display: flex
            align-items: center
            justify-content: center

    &__label
        font-size: 14px
        line-height: 1.2em
        color: $dark-blue
        margin-left: 12px
        cursor: pointer
        font-weight: 500

    &__inner-with-text
        display: flex
        justify-content: center
        flex-direction: column
        align-items: center

.icon-checked
    width: 100%

    &__background
        background-color: #E8EBEF
        color: #fff
        border-radius: 50%
        height: 25px
        width: 25px

.icon-white, .icon-red, .icon-blue
    width: 100%

    &__background
        background-color: #fff
        box-shadow: 0 30px 11px -17px rgba(33,63,107,0.05)

    &__background--transparent
        background-color: transparent !important

    &__background, &__background--transparent
        border-radius: 10px
        min-height: 60px
        border: none
        text-overflow: ellipsis
        overflow: hidden
        white-space: nowrap
        font-weight: 500 !important

        p
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            max-width: 80%

        .icon-checked__background
            display: flex
            justify-content: center
            align-items: center
            background-color: transparent !important
            color: #fff
            border-radius: 5px
            border: 2px solid #8e9eb3
            height: 20px
            width: 20px

    &__background--round
        box-shadow: 0 10px 40px 0 rgba(32,63,106,0.1)

        .icon-checked__background
            border-radius: 50% !important
.icon-red
    &__background--round
        background: $cancel-red
        border-radius: 50% !important

        .icon-checked__background
            border: 2px solid $cancel-red
            height: 25px
            width: 25px

.icon-white
    &__background--round
        .icon-checked__background
            height: 25px!important
            width: 25px!important

.fw-check-box__wrapper.fw-is-selected .icon-checked__background
    background-color: $dark-blue!important
    border: 2px solid $dark-blue
    color: #fff
    border-radius: 5px
    height: 20px
    width: 20px

.fw-check-box__wrapper.fw-is-selected .icon-white__background--round .icon-checked__background
    background-color: $main-green!important
    border: 2px solid $main-green

.fw-check-box__wrapper.fw-is-selected .icon-blue__background--round .icon-checked__background
    background-color: $dark-blue!important
    border: 2px solid $dark-blue

.fw-check-box__wrapper.fw-is-selected .icon-red__background--round .icon-checked__background
    background-color: $cancel-red!important
    border: 2px solid $cancel-red
    height: 25px
    width: 25px
</style>
